import React from 'react'
import { Button } from 'reactstrap'
import DeleteIcon from '@mui/icons-material/Delete'
import { CircularProgress } from '@mui/material'

function DeleteButton(props) {
  const { onClick, loading, disablediv, label } = props
  if (disablediv) {
    return (
      <Button disabled={loading} color='danger' size='sm' onClick={onClick}>
        <DeleteIcon fontSize={'inherit'} />
        {loading ? <CircularProgress size={10} /> : label ? label : ' Poista'}
      </Button>
    )
  }

  return (
    <div className='actions-right'>
      <Button disabled={loading} color='danger' size='sm' onClick={onClick}>
        <DeleteIcon fontSize={'inherit'} />
        {loading ? <CircularProgress size={10} /> : label ? label : ' Poista'}
      </Button>
    </div>
  )
}

export default DeleteButton